<div class="section-divider-wrapper" *transloco="let t">
  <span class="section-divider-wrapper__line"></span>
  <span class="section-divider-wrapper__text">{{t('app.common.or')}}</span>
  <span class="section-divider-wrapper__line"></span>
</div>
